import React from 'react';
import styled from '@emotion/styled';

type TrackLanguageProps = {
  trackNum: number;
  trackLang: string;
};

const TrackLanguage = ({ trackNum, trackLang }: TrackLanguageProps) => {
  return (
    <TrackDiv>
      <strong>
        Track <TrackNumSpan>{trackNum}</TrackNumSpan> :
      </strong>
      <TrackLanguageDiv>{trackLang}</TrackLanguageDiv>
    </TrackDiv>
  );
};

export default TrackLanguage;

const TrackDiv = styled.div`
  display: flex;
  align-items: center;
  line-height: 1.5;
`;

const TrackNumSpan = styled.span`
  min-width: 0.5rem;
  display: inline-block;
  text-align: right;
`;

const TrackLanguageDiv = styled.div`
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  padding-left: ${({ theme }) => theme.spacing(1.5)};
`;
